import { Pipe, PipeTransform } from '@angular/core';
import { DocumentFileTemplateTypeEnum } from '@zaoblako/shared/modules/catalog/enums/document-file-template-type.enum';
import { DocumentFileTemplateTypeEnumI18n } from '@zaoblako/shared/modules/catalog/i18n/document-file-template-type-enum.i18n';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';

@Pipe({
  name: 'documentFileTemplateTypeName',
  standalone: true
})
export class DocumentFileTemplateTypeNamePipe implements PipeTransform {
  public transform(type: DocumentFileTemplateTypeEnum): string {
    return DocumentFileTemplateTypeEnumI18n[I18nLocalesEnum.RU_RU][type] || type;
  }
}
